import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CalsoftInterceptor } from './app/shared/utils/calsoft-interceptor';
import { isDevMode } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';

// bootstrapApplication(AppComponent, {providers: [
//   provideHttpClient(
//     // DI-based interceptors must be explicitly enabled.
//     withInterceptorsFromDi(),
//   ),
//   {provide: HTTP_INTERCEPTORS, useClass: CalsoftInterceptor, multi: true},
// ]});


//old bootstrap


// bootstrapApplication(AppComponent, appConfig)
//   .catch((err) => console.error(err));



  
bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CalsoftInterceptor,
      multi: true,
    }, provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          }),
  ],
}).catch((err) => console.error(err));